













































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({components: {}})

export default class TemplateItem extends Vue {
  @Prop() documentName!: string;
  @Prop() deckTitle!: string;
  @Prop() description!: string;
  @Prop() pages!: number;
}

